import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom';
import { IconButton, Badge, useMediaQuery, useTheme } from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

const styles = {
    iconButton: {
        color: 'black',
    },
    icon: {
        fontSize: '1.9rem',
    },
    iconMobile: {
        fontSize: '1.5rem',

    }
}

export default function CartButton() {
    const { items } = useSelector(state => state.cart)
    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("sm"))

    return (
        <IconButton
            component={Link}
            to={{ pathname: '/cart' }}
            style={styles.iconButton}
            size='large'>
            <Badge badgeContent={items.length} color='error'>
                <ShoppingCartIcon fontSize={mobile ? "medium" : "large"}  />
            </Badge>
        </IconButton>
    );
}